import { Pipe, PipeTransform } from '@angular/core';

import { Feature } from '@vi-iot/client';
import { isNumber } from '../../@store/_common/number-type-helpers';
import { DecimalPipeWrapper } from '../../shared/pipes/decimal-pipe-wrapper/decimal-pipe-wrapper.pipe';

/**
 * @deprecated This pipe should not be used anymore, Please use Value2Pipe
 */
@Pipe({
  name: 'featureValue',
})
export class FeatureValuePipe implements PipeTransform {
  constructor(private decimalPipeWrapper: DecimalPipeWrapper) {}

  transform(feature: Feature<unknown, unknown>, ...args: any[]): any {
    if (!args || !args[0]) {
      return undefined;
    }

    const propertyName = args[0];
    const fallbackValue = args[1];

    const isValue =
      feature &&
      feature.properties &&
      feature.properties[propertyName] &&
      feature.properties[propertyName].value !== undefined;

    if (!isValue) {
      if (isNumber(fallbackValue)) {
        return this.decimalPipeWrapper.transform(fallbackValue);
      } else {
        return fallbackValue;
      }
    }

    const isError =
      feature &&
      feature.properties &&
      feature.properties['status'] &&
      feature.properties['status'].value === 'error';

    if (isError) {
      return fallbackValue;
    }

    if (isNumber(feature.properties[propertyName].value)) {
      return this.decimalPipeWrapper.transform(feature.properties[propertyName].value);
    } else {
      return feature.properties[propertyName].value;
    }
  }
}
